import axios from 'axios';
import { buildLocalizedUrl } from '../utils/locale';
// Ensures the global axios → notification bridge is installed even on pages
// that pull this module before the packs entry has run.
import '../utils/axios_setup';

export default {
  deleteGame(id) {
    this.addToken();
    return axios.delete(`${buildLocalizedUrl('scheduler/games')}/${id}.json`).then((response) => response.data);
  },

  deleteTraining(id) {
    this.addToken();
    return axios.delete(`${buildLocalizedUrl('scheduler/trainings')}/${id}.json`).then((response) => response.data);
  },

  addToken() {
    const token = document.querySelector('[name=csrf-token]').content;
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
  },
};
